import { constants } from '../constants';

const INITIAL_STATE = {
  loading: false,
  coupons: [],
  header: {},
  footer: {},
  total: 0,
  selectedCoupon: {},
  couponExport: {},
  pendingCouponCreation: null,
};

export const couponsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.coupons.SET_COUPONS_LOADING:
      return {
        ...state,
        loading: action.flag,
      };
    case constants.coupons.SET_COUPONS:
      return {
        ...state,
        coupons: action.coupons,
        header: action.header,
        footer: action.footer,
        total: action.count,
      };
    case constants.coupons.SET_COUPON:
      return {
        ...state,
        selectedCoupon: action.coupon,
      };
    case constants.coupons.SET_COUPONS_EXPORT_IDENTIFIER:
      return {
        ...state,
        couponExport: action.identifier,
      };
    case constants.coupons.SET_PENDING_COUPON_CREATION:
      return {
        ...state,
        pendingCouponCreation: action.pendingCouponCreation,
      };
    case constants.coupons.CLEAR_PENDING_COUPON_CREATION:
      return {
        ...state,
        pendingCouponCreation: null,
      };
    case constants.coupons.CLEAR_COUPONS:
      return {
        ...state,
        loading: false,
        coupons: [],
        header: {},
        footer: {},
        total: 0,
      };
    default:
      return state;
  }
};
